import { BADGE_TYPES, TOOLBAR_ACTIONS } from '../enums/badge.enum'
import { BADGE_SIDES } from '../enums/badge.enum'

export type Badge = {
  badge_type: BADGE_TYPES
  title: string
  description: string
  icon: string
  isAvailable: boolean
}

export type BadgeSide = {
  badge_side: BADGE_SIDES
  title: string
  isActive: boolean
}

export type ToolbarAction = {
  action: TOOLBAR_ACTIONS
  payload?: number | BADGE_SIDES
}

export type TemplateLayout = {
  type: BADGE_TYPES
  width: number
  height: number
}

export type FormTab = {
  name: string
  action_button_name?: string
  action_button_style?: string
  fields: Partial<BasicField>[][]
  child_fields?: BasicField[][]
}

export type BasicField = {
  id?: String
  field_type: string
  name: string
  label: string
}

export enum FormBuilderCategory {
  IDENTITY = 'Identity',
  AGE = 'Age',
  WORK_EDUCATION = 'Work / Education',
  CONTACT = 'Contact',
  LOCATION = 'Location',
  APPEARANCE = 'Appearance',
  CUSTOM_ELEMENTS = 'Custom Elements',
  FAVORITE = 'Favorite'
}

// Add a constant for category order
export const CATEGORY_ORDER = [
  FormBuilderCategory.FAVORITE,
  FormBuilderCategory.IDENTITY,
  FormBuilderCategory.AGE,
  FormBuilderCategory.WORK_EDUCATION,
  FormBuilderCategory.CONTACT,
  FormBuilderCategory.LOCATION,
  FormBuilderCategory.APPEARANCE,
  FormBuilderCategory.CUSTOM_ELEMENTS
]

export enum FormBuilderFieldType {
  FULL_NAME = 'FULL_NAME',
  EMAIL = 'EMAIL',
  PHONE_NUMBER = 'PHONE_NUMBER', // PHONE
  COUNTRY = 'COUNTRY',
  ORGANIZATION = 'ORGANIZATION',
  JOB_TITLE = 'JOB_TITLE',
  TEXT = 'TEXT', // PLAIN_TEXT
  NUMERIC = 'NUMERIC',
  DATE = 'DATE',
  LINE_SEPARATOR = 'LINE_SEPARATOR',
  IDENTITY = 'IDENTITY',
  CITY = 'CITY',
  AI_FACIAL_RECOGNITION = 'AI_FACIAL_RECOGNITION',
  GENDER = 'GENDER',
  AGE_GROUP = 'AGE_GROUP',
  PLAIN_TEXT = 'PLAIN_TEXT',
  RADIO = 'RADIO',
  CHECKBOX = 'CHECKBOX',
  URL = 'URL',
  UPLOAD = 'UPLOAD',
  INFORMATION_MESSAGE = 'INFORMATION_MESSAGE',
  WARNING_MESSAGE = 'WARNING_MESSAGE',
  STAR_RATING = 'STAR_RATING',
  UPLOAD_PHOTO = 'UPLOAD'
}

export type VariableElementResponse = {
  field_type: string
  label: string
  id?: string
  weight?: number
  value?: string
}
